module.exports = __webpack_public_path__ + "img/success-icons.db6535de.svg";